// components/TagInput.jsx 🧠
import React, { useState } from "react";
import "./styles/TagInput.css"; // We'll style this

const TagInput = ({ tags, setTags, placeholder = "Add IoC tags" }) => {
  const [inputValue, setInputValue] = useState("");

  const handleKeyDown = (e) => {
    if ((e.key === "Enter" || e.key === ",") && inputValue.trim()) {
      e.preventDefault();
      const newTag = inputValue.trim();
      if (!tags.includes(newTag)) {
        setTags([...tags, newTag]);
      }
      setInputValue("");
    } else if (e.key === "Backspace" && !inputValue && tags.length > 0) {
      setTags(tags.slice(0, -1));
    }
  };

  const handleRemove = (index) => {
    const updated = [...tags];
    updated.splice(index, 1);
    setTags(updated);
  };

  return (
    <div className="tag-input-wrapper form-control text-light border-0" style={{ background: "#3b3b3b" }}>
      {tags.map((tag, index) => (
        <span key={index} className="tag-pill">
          {tag}
          <button type="button" className="remove-tag-btn" onClick={() => handleRemove(index)}>×</button>
        </span>
      ))}
      <input
        className="tag-input-field"
        placeholder={placeholder}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        style={{ background: "transparent", border: "none", outline: "none", color: "#fff", flex: 1 }}
      />
    </div>
  );
};

export default TagInput;
